import { Settings } from "../../../Settings";
import NumberFormatter from "../../../util/NumberFormatter";
import Totals from "../../crew/Totals";
import Values from "../../value/Values";
import SkillNode from "../SkillNode";

export default class FallSpeedBonusSkillNode extends SkillNode {
    /**
     * @param {string} id 
     * @param {string} description 
     * @param {Totals} totals
     * @param {string} iconFileName 
     * @param {BigNum} cost 
     * @param {Values} values
     */
    constructor(id, totals, iconFileName, cost, purchaseListener, values) {
        super(id, 'Fall Speed +' + NumberFormatter.formatNumber(Settings.skill.bonus.fallSpeedMuliplierPerUgrade), null, totals, 
            iconFileName, cost, purchaseListener);

        /**
         * @constant
         * @type {Values}
         */
        this.values = values;
    }

    /**
     * @returns {string}
     */
    getDescription() {
        const speedMultiplier = 1 + (this.values.fallSpeedUpgrades.getValue() * Settings.skill.bonus.fallSpeedMuliplierPerUgrade);
        return 'FallSpeed: x' + NumberFormatter.formatNumber(speedMultiplier);
    }

    /**
     * @override
     */
    onPurchase() {
        if (super.onPurchase()) {
            this.applyUpgrade();
            return true;
        }
        else {
            return false;
        }
    }

    /**
     * @override
     */
    onPurchaseFromSave() {
        this.applyUpgrade();
        super.onPurchaseFromSave();
    }

    /**
     * @private
     */
    applyUpgrade() {
        this.values.fallSpeedUpgrades.incrementValue(1);
    }

}